export const UNIQUE_SYMBOL = 'й';
